import React from 'react';
import './featureContent.css';

const ARROW_DOWN_ICON = (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="5" x2="12" y2="19"/>
        <polyline points="19 12 12 19 5 12"/>
    </svg>
);

/**
 * Standard hero CTA group for feature pages: a primary "Start Free" button that
 * smooth-scrolls to the download section, plus an optional secondary button that
 * smooth-scrolls to the page's main content section.
 *
 * @param {string} primaryLabel - primary button label (e.g. "Start Free")
 * @param {string} primaryTarget - element id the primary button scrolls to
 * @param {string} secondaryLabel - optional secondary button label
 * @param {string} secondaryTarget - element id the secondary button scrolls to
 */
function FeatureHeroCta({ primaryLabel, primaryTarget, secondaryLabel, secondaryTarget }) {
    const scrollTo = (id) => (e) => {
        e.preventDefault();
        const el = document.getElementById(id);
        if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="fc-hero-cta-group">
            <a href={`#${primaryTarget}`} onClick={scrollTo(primaryTarget)} className="fc-btn fc-hero-cta">
                <span>{primaryLabel}</span>
                {ARROW_DOWN_ICON}
            </a>
            {secondaryLabel && secondaryTarget && (
                <a href={`#${secondaryTarget}`} onClick={scrollTo(secondaryTarget)} className="fc-btn-secondary">
                    <span>{secondaryLabel}</span>
                    {ARROW_DOWN_ICON}
                </a>
            )}
        </div>
    );
}

export default FeatureHeroCta;
